import urlHelper from '../helpers/url'

const yaTiene = () => {
    console.log('Yatenia');
    urlHelper.returnBack()
}

export default yaTiene;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/yaTiene.js